export const colors = [
    '#ff6b00',
    '#8456E5',
    '#FF4754',
    '#2AB27B',
    '#FFB126',
    '#2CA8F4',
    '#F2508C',
    '#0094F7'
];